import ChipsList from './chips-list';
export default ChipsList;
